import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { IconSchool } from "@tabler/icons-react";

import { useScreen } from "Screen/ScreenContext";
import CreateCommunityModal from "@components/_modals/Community/CreateCommunityModal";

import useAttachCommunity from "./hooks/useAttachCommunity";
import AttachCommunityView from "./view";

/**
 * Creator — attach community controller (§6.10). Route: mentoring/:enrollmentId/
 * attach. Publishes the breadcrumb (Minhas mentorias › {program} › Vincular
 * comunidade), renders the view, and hosts the "Criar nova comunidade" modal —
 * with redirectOnSuccess disabled so creating a community keeps the user here
 * (the new community is auto-selected once the list refreshes).
 */
export default function MentoringAttach() {
  const { enrollmentId } = useParams();
  const navigate = useNavigate();
  const { setBreadcrumb } = useScreen();

  const attach = useAttachCommunity(enrollmentId);
  const programName = attach.enrollment?.program?.name;

  useEffect(() => {
    document.title = "Vincular comunidade | Ginastee";
    setBreadcrumb([
      { label: "Minhas mentorias", href: "/mentoring", icon: <IconSchool size={18} /> },
      { label: programName ?? "Mentoria", href: `/mentoring/${enrollmentId}` },
      { label: "Vincular comunidade" },
    ]);
    return () => setBreadcrumb(null);
  }, [setBreadcrumb, programName, enrollmentId]);

  function handleOpenDetail() {
    navigate(`/mentoring/${enrollmentId}`);
  }

  return (
    <>
      <AttachCommunityView {...attach} onOpenDetail={handleOpenDetail} />

      <CreateCommunityModal
        open={attach.createOpen}
        onClose={attach.closeCreate}
        onSuccess={attach.onCommunityCreated}
        redirectOnSuccess={false}
      />
    </>
  );
}
